export default __webpack_public_path__ + "static/media/icon_teams_32.5d563ea9.svg";